// src/routes/PharmacyRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import RoleBasedRoute from '../components/auth/RoleBasedRoute';

// Pharmacy Pages
import PharmacyDashboard from '../pages/pharmacy/PharmacyDashboard';
import ManageInventory from '../pages/pharmacy/ManageInventory';
import ManageOrders from '../pages/pharmacy/ManageOrders';
import PrescriptionVerification from '../pages/pharmacy/PrescriptionVerification';
import DeliveryManagement from '../pages/pharmacy/DeliveryManagement';
import Sales from '../pages/pharmacy/Sales';
import Analytics from '../pages/pharmacy/Analytics';
import PharmacyProfile from '../pages/pharmacy/PharmacyProfile';
import PharmacySubscription from '../pages/pharmacy/PharmacySubscription';

const PharmacyRoutes = () => {
  return (
    <ProtectedRoute>
      <RoleBasedRoute allowedRoles={['pharmacy']}>
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={
              <>
                <Helmet>
                  <title>Pharmacy Dashboard - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <PharmacyDashboard />
              </>
            } />
            
            <Route path="inventory" element={
              <>
                <Helmet>
                  <title>Manage Inventory - MediGo Pharmacy Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageInventory />
              </>
            } />
            
            <Route path="subscription" element={
<>
<Helmet>
  <title>Subscription Plans - MediGo Pharmacy Portal</title>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>
<PharmacySubscription />
</>
            }
/>

            <Route path="orders" element={
              <>
                <Helmet>
                  <title>Manage Orders - MediGo Pharmacy Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageOrders />
              </>
            } />
            
            <Route path="prescriptions" element={
              <>
                <Helmet>
                  <title>Prescription Verification - MediGo Pharmacy Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <PrescriptionVerification />
              </>
            } />
            
            <Route path="delivery" element={
              <>
                <Helmet>
                  <title>Delivery Management - MediGo Pharmacy Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <DeliveryManagement />
              </>
            } />
            
            <Route path="sales" element={
              <>
                <Helmet>
                  <title>Sales Report - MediGo Pharmacy Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Sales />
              </>
            } />
            
            <Route path="analytics" element={
              <>
                <Helmet>
                  <title>Analytics Dashboard - MediGo Pharmacy Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Analytics />
              </>
            } />
            
            <Route path="profile" element={
              <>
                <Helmet>
                  <title>Pharmacy Profile - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <PharmacyProfile />
              </>
            } />
          </Route>
        </Routes>
      </RoleBasedRoute>
    </ProtectedRoute>
  );
};

export default PharmacyRoutes;